module.exports = __webpack_public_path__ + "img/webhooks-empty-state.4bd5b14f.svg";